module.exports = __webpack_public_path__ + "img/system-dungeon-title.39d6fc76.png";